var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$t, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$e = {}, $13c40c34b78c8ee2$var$c = [], $13c40c34b78c8ee2$var$s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $13c40c34b78c8ee2$var$a(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$h(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, i) {
    var t, o, r, f = {};
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $13c40c34b78c8ee2$var$y(l, f, t, o, null);
}
function $13c40c34b78c8ee2$var$y(n, i, t, o, r) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$13c40c34b78c8ee2$var$u : r
    };
    return null == r && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(f), f;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$k(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$k(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$k(n) : null;
}
function $13c40c34b78c8ee2$var$b(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$b(n);
    }
}
function $13c40c34b78c8ee2$var$m(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$t.push(n) && !$13c40c34b78c8ee2$var$g.__r++ || $13c40c34b78c8ee2$var$r !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$r = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$o)($13c40c34b78c8ee2$var$g);
}
function $13c40c34b78c8ee2$var$g() {
    for(var n; $13c40c34b78c8ee2$var$g.__r = $13c40c34b78c8ee2$var$t.length;)n = $13c40c34b78c8ee2$var$t.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), $13c40c34b78c8ee2$var$t = [], n.some(function(n) {
        var l, u, i, t, o, r;
        n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = $13c40c34b78c8ee2$var$a({}, t)).__v = t.__v + 1, $13c40c34b78c8ee2$var$j(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [
            o
        ] : null, u, null == o ? $13c40c34b78c8ee2$var$k(t) : o, t.__h), $13c40c34b78c8ee2$var$z(u, t), t.__e != o && $13c40c34b78c8ee2$var$b(t)));
    });
}
function $13c40c34b78c8ee2$var$w(n, l, u, i, t, o, r, f, s, a) {
    var h, v, p, _, b, m, g, w = i && i.__k || $13c40c34b78c8ee2$var$c, A = w.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (_ = u.__k[h] = null == (_ = l[h]) || "boolean" == typeof _ ? null : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _ ? $13c40c34b78c8ee2$var$y(null, _, null, null, _) : Array.isArray(_) ? $13c40c34b78c8ee2$var$y($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: _
    }, null, null, null) : _.__b > 0 ? $13c40c34b78c8ee2$var$y(_.type, _.props, _.key, null, _.__v) : _)) {
        if (_.__ = u, _.__b = u.__b + 1, null === (p = w[h]) || p && _.key == p.key && _.type === p.type) w[h] = void 0;
        else for(v = 0; v < A; v++){
            if ((p = w[v]) && _.key == p.key && _.type === p.type) {
                w[v] = void 0;
                break;
            }
            p = null;
        }
        $13c40c34b78c8ee2$var$j(n, _, p = p || $13c40c34b78c8ee2$var$e, t, o, r, f, s, a), b = _.__e, (v = _.ref) && p.ref != v && (g || (g = []), p.ref && g.push(p.ref, null, _), g.push(v, _.__c || b, _)), null != b ? (null == m && (m = b), "function" == typeof _.type && _.__k === p.__k ? _.__d = s = $13c40c34b78c8ee2$var$x(_, s, n) : s = $13c40c34b78c8ee2$var$P(n, _, p, w, b, s), "function" == typeof u.type && (u.__d = s)) : s && p.__e == s && s.parentNode != n && (s = $13c40c34b78c8ee2$var$k(p));
    }
    for(u.__e = m, h = A; h--;)null != w[h] && ("function" == typeof u.type && null != w[h].__e && w[h].__e == u.__d && (u.__d = $13c40c34b78c8ee2$var$k(i, h + 1)), $13c40c34b78c8ee2$var$N(w[h], w[h]));
    if (g) for(h = 0; h < g.length; h++)$13c40c34b78c8ee2$var$M(g[h], g[++h], g[++h]);
}
function $13c40c34b78c8ee2$var$x(n, l, u) {
    for(var i, t = n.__k, o = 0; t && o < t.length; o++)(i = t[o]) && (i.__ = n, l = "function" == typeof i.type ? $13c40c34b78c8ee2$var$x(i, l, u) : $13c40c34b78c8ee2$var$P(u, i, i, t, i.__e, l));
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$P(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function $13c40c34b78c8ee2$var$C(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $13c40c34b78c8ee2$var$H(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $13c40c34b78c8ee2$var$H(n, o, l[o], u[o], i);
}
function $13c40c34b78c8ee2$var$$(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$s.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$H(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $13c40c34b78c8ee2$var$$(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $13c40c34b78c8ee2$var$$(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? $13c40c34b78c8ee2$var$T : $13c40c34b78c8ee2$var$I, o) : n.removeEventListener(l, o ? $13c40c34b78c8ee2$var$T : $13c40c34b78c8ee2$var$I, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
        else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
    }
}
function $13c40c34b78c8ee2$var$I(n) {
    this.l[n.type + !1]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
}
function $13c40c34b78c8ee2$var$T(n) {
    this.l[n.type + !0]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
}
function $13c40c34b78c8ee2$var$j(n, u, i, t, o, r, f, e, c) {
    var s, h, v, y, p, k, b, m, g, x, A, P = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof P) {
            if (m = u.props, g = (s = P.contextType) && t[s.__c], x = s ? g ? g.props.value : s.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in P && P.prototype.render ? u.__c = h = new P(m, x) : (u.__c = h = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(m, x), h.constructor = P, h.render = $13c40c34b78c8ee2$var$O), g && g.sub(h), h.props = m, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != P.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c40c34b78c8ee2$var$a({}, h.__s)), $13c40c34b78c8ee2$var$a(h.__s, P.getDerivedStateFromProps(m, h.__s))), y = h.props, p = h.state, v) null == P.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
            else {
                if (null == P.getDerivedStateFromProps && m !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, x) || u.__v === i.__v) {
                    h.props = m, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), h.__h.length && f.push(h);
                    break n;
                }
                null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, x), null != h.componentDidUpdate && h.__h.push(function() {
                    h.componentDidUpdate(y, p, k);
                });
            }
            h.context = x, h.props = m, h.state = h.__s, (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r) && s(u), h.__d = !1, h.__v = u, h.__P = n, s = h.render(h.props, h.state, h.context), h.state = h.__s, null != h.getChildContext && (t = $13c40c34b78c8ee2$var$a($13c40c34b78c8ee2$var$a({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, p)), A = null != s && s.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $13c40c34b78c8ee2$var$w(n, Array.isArray(A) ? A : [
                A
            ], u, i, t, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $13c40c34b78c8ee2$var$L(i.__e, u, i, t, o, r, f, c);
        (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $13c40c34b78c8ee2$var$z(n, u) {
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$L(l, u, i, t, o, r, f, c) {
    var s, a, v, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (o = !0), null != r) {
        for(; _ < r.length; _++)if ((s = r[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, r[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), r = null, c = !1;
    }
    if (null === d) y === p || c && l.data === p || (l.data = p);
    else {
        if (r = r && $13c40c34b78c8ee2$var$n.call(l.childNodes), a = (y = i.props || $13c40c34b78c8ee2$var$e).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !c) {
            if (null != r) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (v || a) && (v && (a && v.__html == a.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
        }
        if ($13c40c34b78c8ee2$var$C(l, p, y, o, c), v) u.__k = [];
        else if (_ = u.props.children, $13c40c34b78c8ee2$var$w(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, o && "foreignObject" !== d, r, f, r ? r[0] : i.__k && $13c40c34b78c8ee2$var$k(i, 0), c), null != r) for(_ = r.length; _--;)null != r[_] && $13c40c34b78c8ee2$var$h(r[_]);
        c || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && $13c40c34b78c8ee2$var$H(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $13c40c34b78c8ee2$var$H(l, "checked", _, y.checked, !1));
    }
    return l;
}
function $13c40c34b78c8ee2$var$M(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $13c40c34b78c8ee2$var$N(n, u, i) {
    var t, o;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $13c40c34b78c8ee2$var$M(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null;
    }
    if (t = n.__k) for(o = 0; o < t.length; o++)t[o] && $13c40c34b78c8ee2$var$N(t[o], u, "function" != typeof n.type);
    i || null == n.__e || $13c40c34b78c8ee2$var$h(n.__e), n.__e = n.__d = void 0;
}
function $13c40c34b78c8ee2$var$O(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, i, t) {
    var o, r, f;
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $13c40c34b78c8ee2$var$j(i, u = (!o && t || i).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), r || $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$e, void 0 !== i.ownerSVGElement, !o && t ? [
        t
    ] : r ? null : i.firstChild ? $13c40c34b78c8ee2$var$n.call(i.childNodes) : null, f, !o && t ? t : r ? r.__e : i.firstChild, o), $13c40c34b78c8ee2$var$z(f, u);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, i) {
    var t, o, r, f = $13c40c34b78c8ee2$var$a({}, l.props);
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : i), $13c40c34b78c8ee2$var$y(l.type, f, t || l.key, o || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $13c40c34b78c8ee2$var$f++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some($13c40c34b78c8ee2$var$m);
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$c.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l) {
        for(var u, i, t; l = l.__;)if ((u = l.__c) && !u.__) try {
            if ((i = u.constructor) && null != i.getDerivedStateFromError && (u.setState(i.getDerivedStateFromError(n)), t = u.__d), null != u.componentDidCatch && (u.componentDidCatch(n), t = u.__d), t) return u.__E = u;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$a({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$a({}, u), this.props)), n && $13c40c34b78c8ee2$var$a(u, n), null != n && this.__v && (l && this.__h.push(l), $13c40c34b78c8ee2$var$m(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$m(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$t = [], $13c40c34b78c8ee2$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$g.__r = 0, $13c40c34b78c8ee2$var$f = 0;





var $4042c3f7d6f74427$export$1fc8f52ad1810e52 = /*#__PURE__*/ function(ItemType) {
    ItemType[ItemType["Image"] = 0] = "Image";
    ItemType[ItemType["Video"] = 1] = "Video";
    return ItemType;
}({});
const $4042c3f7d6f74427$export$17a1664ed1fb5d6f = [
    {
        type: 0,
        title: "Tourism Poster- BC",
        description: "<b>3d Digital Media</b>\nDecember 2025\n<i>Independent Work</i>\n\nA depiction of Landslide Lake, on Vancouver Island, British Columbia.",
        url: "res/art/matxmas.webp"
    },
    {
        type: 0,
        title: "True Love Exists Only...",
        description: "<b>3d Digital Media</b>\nNovember 2025\n<i>Independent Work</i>\n\nFor new people, in the next world. It is too late for us. \n Fanart of Madoka Magica, rendered in Blender 3d, painted in Clip Studio.",
        url: "res/art/truelovefinal.webp"
    },
    {
        type: 1,
        title: "Mysterious Woman.",
        description: "<b>3d Digital Media</b>\nFebuary 2025\n<i>Independent Work</i>\n\nA mockery of what it means to be human. Or an homage, depending on whom you ask. Made, fully rigged, and animated, in Blender 3d.",
        url: "res/art/moldlady.webm"
    },
    {
        type: 0,
        title: "Saprophytic Poster",
        description: "<b>2d Digital Media</b>\nOctober 2024\n<i>Independent Work</i>\n\nAn experiment on what promotional art for a horror game I've been designing would look like. Painted in Clip Studio Paint",
        url: "res/art/saprophyticposterformatted.webp"
    },
    {
        type: 0,
        title: "Ghosts of the Madre",
        description: "<b>2d Digital Media</b>\nSeptember 2025\n<i>Independent Work</i>\n\nFanart of the video game 'Fallout: New Vegas,' by Obsidian Interactive. Painted in Clip Studio Paint",
        url: "res/art/ghostsofthemadre.webp"
    },
    {
        type: 0,
        title: "First, do no Harm",
        description: "<b>2d Digital Media</b>\nSeptember 2025\n<i>Independent Work</i>\n\nFanart of the online web serial <i>Worm</i>, by John C. McCrae.",
        url: "res/art/dallon.webp"
    },
    {
        type: 0,
        title: "Royalty",
        description: "<b>2d Digital Media</b>\nDecember 2024\n<i>Independent Work</i>\n\nA monarch sits on her throne. Made in Blender and Clip Studio Paint.",
        url: "res/art/monarchpaintingafter.webp"
    },
    {
        type: 0,
        title: "Office Concept Art",
        description: "<b>3d Digital Media</b>\nDecember 2023\n<i>Independent Work</i>\n\nA potential design for an office complex abandoned in the 60's. Made in Blender",
        url: "res/art/officetest.webp"
    },
    {
        type: 1,
        title: "Ancient Catacombs",
        description: "<b>3d Digital Media</b>\nNovember 2024\n<i>Independent Work</i>\n\nThe catacombs beneath the earth, though rich in mineral, best lay untainted. Fools and Desperate men alike beg to differ. Made in Blender.",
        url: "res/art/catacombs.webm"
    },
    {
        type: 1,
        title: "Soothshatter",
        description: "<b>3d Digital Media</b>\nAugust 2023\n<i>Independent Work</i>\n\nA husk of a person- their identity shattered to the winds. Made in Blender",
        url: "res/art/shatter.webm"
    },
    {
        type: 1,
        title: "Maya",
        description: "<b>3d Digital Media</b>\nOctober 2024\n<i>Independent Work</i>\n\nA 3d model of Maya, from the webcomic Kill Six Billion Demons- Rigged to support a full range of motion and facial expressions. Made in Blender",
        url: "res/art/maya.webm"
    },
    {
        type: 0,
        title: "Tarot Cards",
        description: "<b>2d Digital Media</b>\nAugust 2024\n<i>Independent Work</i>\n\nA series of lighting studies made through the form of Tarot Cards. From top left to bottom right: The High Priestess, The Magician, The Empress, and The Fool.",
        url: "res/art/tarotmerged.webp"
    },
    {
        type: 0,
        title: "Cover Art",
        description: "<b>2d Digital Media</b>\nJuly 2024\n<i>Independent Work</i>\n\nCover art for a story I've been writing in my spare time. Painted from scratch in Clip Studio Paint.",
        url: "res/art/parasiticinfluences.webp"
    },
    {
        type: 0,
        title: "Eden's Wake",
        description: "<b>3d Digital Media</b>\nMay 2025\n<i>Fanart</i>\n\n<i>The entity moved, and everything around them stirred. A thousand hands, a thousand arms, not all attached to the hands, legs, feet, ears, eyes, faces without features, expanses of skin, they twitched and writhed.</i>\n(Worm, 29.x)",
        url: "res/art/eden.webp"
    },
    {
        type: 1,
        title: "Camcorder",
        description: "<b>3d Digital Media</b>\nJune 2024\n<i>Independent Work</i>\n\nA 3d model of a fictional tape camcorder, made Game Ready. 4,449 Tris, with a 2048x2048 PBR texture set.",
        url: "res/art/camcorder.webm"
    },
    {
        type: 1,
        title: "Camcorder Viewmodel",
        description: "<b>3d Digital Media</b>\nJune 2024\n<i>Independent Work</i>\n\nA series of viewmodel animations for said camcorder. The hand and rigging are also made by me.",
        url: "res/art/viewmodelcam.webm"
    },
    {
        type: 0,
        title: "Lillian Keyton",
        description: "<b>3d Digital Media</b>\nApril 2023\n<i>Independent Work</i>\n\nFanart of Lillian Keyton, from the webcomic 'Soulwinder'. Made in Blender",
        url: "res/art/soulwinder.webp"
    },
    {
        type: 0,
        title: "Replacement",
        description: "<b>3d Digital Media</b>\nSeptember 2023\n<i>Independent Work</i>\n\nA fake advertisement for prosthetic upgrades. Made in Blender",
        url: "res/art/molddroid.webp"
    },
    {
        type: 0,
        title: "Pioneer Cosplay",
        description: "<b>Physical Costume</b>\nOctober 2025\n<i>Independent Work</i>\n\nA costume of the Pioneer from 'Satisfactory'- the helmet is 3d printed with LED lights and a fan, the build gun is also fabricated from scratch, and the jumpsuit is sewn together with a welding cowl.",
        url: "res/art/pioneer.webp"
    },
    {
        type: 0,
        title: "Hollow Knight Cosplay",
        description: "<b>Physical Costume</b>\nOctober 2023\n<i>Independent Work</i>\n\nA costume of the Hollow Knight from 'Hollow Knight'- the mask is 3d printed with LEDS run through the eyes, the nail is foam sliced and stacked around a dowel rod, and the cloak is a curtain resewn into strands.",
        url: "res/art/theknight.webp"
    },
    {
        type: 0,
        title: "Tourism Posters",
        description: "<b>3d Digital Media</b>\nDecember 2023\n<i>Independent Work</i>\n\nA series of fake tourism posters for locations in Canada. Made in Blender",
        url: "res/art/merge.webp"
    },
    {
        type: 1,
        title: "Mallory",
        description: "<b>3d Digital Media</b>\nAugust 2023\n<i>Independent Work</i>\n\nFan art of Mallory, from the webcomic 'The Beast of Hadingley Hill'. Made in Blender",
        url: "res/art/hadingleyturn2.webm"
    },
    {
        type: 0,
        title: "BC Tourism Poster",
        description: "<b>3d Digital Media</b>\nDecember 2022\n<i>Independent Work</i>\n\nA fake advertisement for the woods of BC. Made in Blender",
        url: "res/art/tourismposterbc.webp"
    },
    {
        type: 1,
        title: "Forgotten Church",
        description: "<b>3d Digital Media</b>\nJanuary 2023\n<i>Independent Work</i>\n\nA shattered point in space- a eulogy to the forgotton. Made in Blender",
        url: "res/art/thestars.webm"
    },
    {
        type: 0,
        title: "City Skyline",
        description: "<b>3d Digital Media</b>\nJune 2023\n<i>Independent Work</i>\n\nA city that never sleeps. Made in Blender",
        url: "res/art/skiview.webp"
    },
    {
        type: 1,
        title: "Silver Fanart",
        description: "<b>3d Digital Media</b>\nJuly 2023\n<i>Independent Work</i>\n\nFanart of Silver, from the 2d RPG Oneshot. Made in Blender",
        url: "res/art/silver3d.webm"
    },
    {
        type: 1,
        title: "Starfarer",
        description: "<b>3d Digital Media</b>\nJuly 2022\n<i>Independent Work</i>\n\nCharacter modelling and rigging practice, with an added cel shaded twist!",
        url: "res/art/starfarer.webm"
    },
    {
        type: 1,
        title: "Lupe",
        description: "<b>3d Digital Media</b>\nOctober 2022\n<i>Independent Work</i>\n\nA 3d model of Lupe from the webcomic Four Leaf!",
        url: "res/art/lupefourleaf.webm"
    },
    {
        type: 1,
        title: "The Sky.",
        description: "<b>3d Digital Media</b>\nFebuary 2023\n<i>Independent Work</i>\n\nNobody has seen the stars in a hundred years. Made in Blender",
        url: "res/art/thesky.webm"
    },
    {
        type: 1,
        title: "Freefalling",
        description: "<b>3d Digital Media</b>\nSeptember 2022\n<i>Independent Work</i>\n\nFalling from the skyline. Made in Blender",
        url: "res/art/falling.webm"
    },
    {
        type: 1,
        title: "Fight Scene",
        description: "<b>3d Digital Media</b>\nJune 2023\n<i>Independent Work</i>\n\nPracticing animation and 2d effects with a fight scene! Made in Blender",
        url: "res/art/fightscene.webm"
    },
    {
        type: 0,
        title: "Matsterna",
        description: "<b>3d Digital Media</b>\nJuly 2023\n<i>Independent Work</i>\n\nThe Creator of the cosmos. Made in Blender",
        url: "res/art/matsterna.webp"
    },
    {
        type: 0,
        title: "Basic Lands",
        description: "<b>2d Digital Media</b>\nJune 2022\n<i>Independent Work</i>\n\nA set of custom cards designed to function in the card game 'Magic the Gathering'",
        url: "res/art/mtglands.webp"
    },
    {
        type: 0,
        title: "Flumph",
        description: "<b>2d Digital Media</b>\nJune 2022\n<i>Independent Work</i>\n\nAnother custom art card, this time of 'Flumph', from Magic the Gathering",
        url: "res/art/flumph.webp"
    }
];


const $f4e048021dc6e1cd$var$CHECK_LOADED_TIMEOUT = 125;
class $f4e048021dc6e1cd$export$238b7133f33e85a5 extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    constructor(props){
        super(props), // callback is sketchy and doesnt work much of the time
        this.checkLoaded = ()=>{
            if (this.imageRef.current) {
                if (this.imageRef.current.naturalWidth) this.onLoad();
                else setTimeout(this.checkLoaded, $f4e048021dc6e1cd$var$CHECK_LOADED_TIMEOUT);
            } else if (this.videoRef.current) {
                if (this.videoRef.current.width) this.onLoad();
                else setTimeout(this.checkLoaded, $f4e048021dc6e1cd$var$CHECK_LOADED_TIMEOUT);
            }
        }, this.onLoad = ()=>{
            if (this.imageRef.current) {
                this.contentWidth = this.imageRef.current.naturalWidth;
                this.contentHeight = this.imageRef.current.naturalHeight;
            } else if (this.videoRef.current) {
                this.contentWidth = this.videoRef.current.videoWidth;
                this.contentHeight = this.videoRef.current.videoHeight;
            }
            this.resizeCallback();
        }, this.setRenderedSize = (w, h)=>{
            if (this.imageRef.current) {
                this.imageRef.current.width = w;
                this.imageRef.current.height = h;
            } else if (this.videoRef.current) {
                this.videoRef.current.width = w;
                this.videoRef.current.height = h;
            }
        };
        this.name = props.item.title;
        this.resizeCallback = props.resizeCallback;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.imageRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.videoRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
    }
    componentDidMount() {
        if (this.imageRef.current) {
            this.imageRef.current.addEventListener("onload", ()=>{
                this.onLoad();
            });
            if (this.imageRef.current.naturalWidth) {
                this.contentWidth = this.imageRef.current.naturalWidth;
                this.contentHeight = this.imageRef.current.naturalHeight;
            }
        } else if (this.videoRef.current) {
            this.videoRef.current.addEventListener("loadedmetadata", ()=>{
                this.onLoad();
            });
            if (this.videoRef.current.width) {
                this.contentWidth = this.videoRef.current.videoWidth;
                this.contentHeight = this.videoRef.current.videoHeight;
            }
        }
        // callback is sketchy and doesnt work much of the time
        setTimeout(this.checkLoaded, $f4e048021dc6e1cd$var$CHECK_LOADED_TIMEOUT);
    }
    render(props, state, context) {
        return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "art-item",
            style: props.marginLeft ? `left: ${props.marginLeft}px` : ""
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "art-item-cover",
            onClick: ()=>{
                props.artGridRef.showPopup(props.item.index);
            }
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, props.item.title)), props.item.type == (0, $4042c3f7d6f74427$export$1fc8f52ad1810e52).Image ? /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("img", {
            ref: this.imageRef,
            src: props.item.url,
            alt: props.item.title,
            width: props.width,
            height: props.height
        }) : /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("video", {
            ref: this.videoRef,
            muted: true,
            autoPlay: true,
            loop: true,
            width: props.width,
            height: props.height
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("source", {
            src: props.item.url
        })));
    }
}


const $d32c0476c07f1fde$var$ITEM_PADDING = 8;
class $d32c0476c07f1fde$export$95c189e1ec73bcbd extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    constructor(){
        super(), this.resize = ()=>{
            if (this.item1ref.current && this.item2ref.current) {
                var i1 = this.item1ref.current;
                var i2 = this.item2ref.current;
                /*
            total width = (rendered height * el1 width/height ratio) + (rendered height * el2 width/height ratio) + ... + padding
            therefore,
            rendered height = (total width - padding) / (el1 width/height ratio + el2 width/height ratio + ...)
            */ var totalWidth = 1;
                if (this.thisRootRef.current) totalWidth = this.thisRootRef.current.clientWidth;
                if (window.innerWidth > 1184) {
                    // desktop version
                    var denom = i1.contentWidth / i1.contentHeight + i2.contentWidth / i2.contentHeight;
                    var h = 1;
                    if (denom > 0) h = (totalWidth - $d32c0476c07f1fde$var$ITEM_PADDING) / denom;
                    var w = i1.contentWidth * (h / i1.contentHeight);
                    i1.setRenderedSize(w, h);
                    i2.setRenderedSize(totalWidth - w - $d32c0476c07f1fde$var$ITEM_PADDING, h);
                } else {
                    // mobile version
                    var eh1 = i1.contentHeight * (totalWidth / i1.contentWidth);
                    i1.setRenderedSize(totalWidth, eh1);
                    var eh2 = i2.contentHeight * (totalWidth / i2.contentWidth);
                    i2.setRenderedSize(totalWidth, eh2);
                }
            }
            if (this.state.windowInnerWidth > 1184 && window.innerWidth <= 1184) this.setState({
                windowInnerWidth: window.innerWidth
            });
            else if (this.state.windowInnerWidth <= 1184 && window.innerWidth > 1184) this.setState({
                windowInnerWidth: window.innerWidth
            });
        };
        this.thisRootRef = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.item1ref = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.item2ref = (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)();
        this.state = {
            windowInnerWidth: window.innerWidth
        };
        window.addEventListener("resize", this.resize);
    }
    render(props, state, context) {
        return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            ref: this.thisRootRef,
            class: "art-grid-row"
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $f4e048021dc6e1cd$export$238b7133f33e85a5), {
            artGridRef: props.artGridRef,
            ref: this.item1ref,
            item: props.item1,
            width: 0,
            height: 0,
            resizeCallback: this.resize
        }), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $f4e048021dc6e1cd$export$238b7133f33e85a5), {
            artGridRef: props.artGridRef,
            ref: this.item2ref,
            item: props.item2,
            width: 0,
            height: 0,
            resizeCallback: this.resize,
            marginLeft: window.innerWidth > 1184 ? $d32c0476c07f1fde$var$ITEM_PADDING : 0
        }));
    }
}





const $1539112f532359e2$var$MOUSE_MOTION_TIMEOUT = 4000;
const $1539112f532359e2$var$CHECK_MOUSE_MOTION_INTERVAL = 50;
class $1539112f532359e2$export$129a32eedafa97c5 extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    constructor(props){
        super(props), this.onMouseMotion = ()=>{
            this.lastMouseMotion = Date.now();
        }, this.checkMouseMotion = ()=>{
            if (!this.visible) this.lastMouseMotion = Date.now();
            else {
                if (Date.now() > this.lastMouseMotion + $1539112f532359e2$var$MOUSE_MOTION_TIMEOUT) // if mouse has not been moved for a while
                // and we did not already hide
                {
                    if (this.itemRefs[0].current && !this.itemRefs[0].current.classList.contains("popup-item-hidden")) this.itemRefs.map((item)=>{
                        if (item.current) item.current.classList.add("popup-item-hidden");
                    });
                } else // if mouse has been moved recently
                // and we are still hidden
                if (this.itemRefs[0].current && this.itemRefs[0].current.classList.contains("popup-item-hidden")) this.itemRefs.map((item)=>{
                    if (item.current) item.current.classList.remove("popup-item-hidden");
                });
            }
            setTimeout(this.checkMouseMotion, $1539112f532359e2$var$CHECK_MOUSE_MOTION_INTERVAL);
        }, this.onLeftClicked = ()=>{
            if (this.index > 0) this.artGridRef.showPopup(this.index - 1);
        }, this.onRightClicked = ()=>{
            if (this.index < (0, $4042c3f7d6f74427$export$17a1664ed1fb5d6f).length - 1) this.artGridRef.showPopup(this.index + 1);
        }, this.onXClicked = ()=>{
            this.artGridRef.hidePopup();
        };
        this.artGridRef = props.artGridRef;
        this.visible = props.visible;
        this.index = props.index;
        this.itemRefs = [];
        for(var i = 0; i < 4; i++)this.itemRefs.push((0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43)());
        this.lastMouseMotion = Date.now();
        window.addEventListener("mousemove", this.onMouseMotion);
        setTimeout(this.checkMouseMotion, $1539112f532359e2$var$CHECK_MOUSE_MOTION_INTERVAL);
    }
    render(props, state, context) {
        this.artGridRef = props.artGridRef;
        this.visible = props.visible;
        this.index = props.index;
        var item = (0, $4042c3f7d6f74427$export$17a1664ed1fb5d6f)[props.index];
        var iDesc = {
            __html: item.description
        };
        return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "popup",
            style: props.visible ? "display: block" : "display: none"
        }, item.type == (0, $4042c3f7d6f74427$export$1fc8f52ad1810e52).Image ? /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("img", {
            class: "popup-content",
            src: item.url,
            alt: item.title
        }) : /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("video", {
            key: item.url,
            class: "popup-content",
            muted: true,
            autoPlay: true,
            loop: true
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("source", {
            src: item.url
        })), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "popup-row"
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "popup-column"
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            ref: this.itemRefs[0],
            class: "top-left popup-item"
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h2", null, item.title), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
            dangerouslySetInnerHTML: iDesc
        })), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            ref: this.itemRefs[1],
            class: "bottom-left popup-item"
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
            onClick: this.onLeftClicked
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("img", {
            src: "res/special/left-button.png",
            alt: "left",
            width: 64,
            height: 64,
            class: this.index <= 0 ? "disabled" : "",
            style: "object-fit: contain;"
        })))), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "popup-column"
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            ref: this.itemRefs[2],
            class: "top-right popup-item"
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
            onClick: this.onXClicked
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("img", {
            src: "res/special/x-button.png",
            alt: "close",
            width: 64,
            height: 64,
            style: "object-fit: contain;"
        }))), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            ref: this.itemRefs[3],
            class: "bottom-right popup-item"
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
            onClick: this.onRightClicked
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("img", {
            src: "res/special/right-button.png",
            alt: "right",
            width: 64,
            height: 64,
            class: this.index >= (0, $4042c3f7d6f74427$export$17a1664ed1fb5d6f).length - 1 ? "disabled" : "",
            style: "object-fit: contain;"
        }))))));
    }
}


class $ac10c7814c9ca36f$export$50e0ab684c012c40 extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    constructor(){
        super(), this.showPopup = (itemIndex)=>{
            this.setState({
                popupVisible: true,
                popupIndex: itemIndex
            });
        }, this.hidePopup = ()=>{
            this.setState({
                popupVisible: false
            });
        };
        this.state = {
            popupVisible: false,
            popupIndex: 0
        };
    }
    render(props, state, context) {
        var pairs = [];
        for(var i = 0; i < (0, $4042c3f7d6f74427$export$17a1664ed1fb5d6f).length; i += 2){
            let one = (0, $4042c3f7d6f74427$export$17a1664ed1fb5d6f)[i];
            one.index = i;
            let two = (0, $4042c3f7d6f74427$export$17a1664ed1fb5d6f)[i + 1];
            two.index = i + 1;
            pairs.push([
                one,
                two
            ]);
        }
        if (this.state.popupVisible) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "scroll";
        return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $1539112f532359e2$export$129a32eedafa97c5), {
            artGridRef: this,
            visible: this.state.popupVisible,
            index: this.state.popupIndex
        }), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "art-grid"
        }, pairs.map((pair)=>/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $d32c0476c07f1fde$export$95c189e1ec73bcbd), {
                artGridRef: this,
                item1: pair[0],
                item2: pair[1]
            }))));
    }
}


(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $ac10c7814c9ca36f$export$50e0ab684c012c40), null), document.getElementById("art-grid-root"));


//# sourceMappingURL=art.0ffe3316.js.map
